declare global {
  interface Window {
    dataLayer: Array<Record<string, any>>;
  }
}

export interface EnhancedConversionsPayload {
  user_data: {
    full_name: string,
    user_email: string,
    phone_number: string
  },
}


const useEnhancedConversions = () => {

  const setEnhancedConversions = (payload: EnhancedConversionsPayload) => {
    const { user_data } = payload;
    const [first_name, last_name] = user_data.full_name.split(' ', 2)
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      user_data: {
        email: user_data.user_email.toLowerCase(),
        phone_number: user_data.phone_number,
        address: {
          first_name: first_name,
          last_name: last_name
        },
      }
    });
  };

  return {
    setEnhancedConversions
  }

};

export default useEnhancedConversions;